import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Auth screen imports
import SplashScreen from '../../screens/auth/SplashScreen';
import OnboardingScreen from '../../screens/auth/OnboardingScreen';
import OnboardingChoiceScreen from '../../screens/auth/OnboardingChoiceScreen';
import InvitationVerificationScreen from '../../screens/auth/InvitationVerificationScreen';
import SignUpScreen from '../../screens/auth/SignUpScreen';
import LoginScreen from '../../screens/auth/LoginScreen';
import PhoneVerificationScreen from '../../screens/auth/PhoneVerificationScreen';
import CodeVerificationScreen from '../../screens/auth/CodeVerificationScreen';
import ForgotPasswordScreen from '../../screens/auth/ForgotPasswordScreen';
import PasswordVerificationCodeScreen from '../../screens/auth/PasswordVerificationCodeScreen';
import ResetPasswordScreen from '../../screens/auth/ResetPasswordScreen';
import EmailVerificationNoticeScreen from '../../screens/auth/EmailVerificationNoticeScreen';
import EmailVerificationResultScreen from '../../screens/auth/EmailVerificationResultScreen';
import TwoFactorVerificationScreen from '../../screens/auth/TwoFactorVerificationScreen';
import TotpSetupScreen from '../../screens/auth/TotpSetupScreen';
import TotpVerificationScreen from '../../screens/auth/TotpVerificationScreen';
import SmsVerificationScreen from '../../screens/auth/SmsVerificationScreen';
import BiometricSetupPromptScreen from '../../screens/auth/BiometricSetupPromptScreen';
import SecurityChooserScreen from '../../screens/auth/SecurityChooserScreen';
import UnlockVaultScreen from '../../screens/auth/UnlockVaultScreen';

// Onboarding screen imports
import UserOnboardingScreen from '../../screens/onboarding/UserOnboardingScreen';
import WhatIsNextScreen from '../../screens/onboarding/WhatIsNextScreen';

// AI Onboarding screen imports
import {
  AIOnboardingWelcomeScreen,
  AIOnboardingTutorialScreen,
  AIOnboardingChatScreen,
  AIOnboardingPrioritiesScreen,
  AIOnboardingPausedScreen,
} from '../../screens/ai-onboarding';

// Billing screen import

// Legal screens (accessible during signup)
import PrivacyPolicyScreen from '../../screens/profile/PrivacyPolicyScreen';
import TermsOfServiceScreen from '../../screens/profile/TermsOfServiceScreen';

const Stack = createNativeStackNavigator();

export const AuthNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
      }}
    >
      {/* Auth Screens */}
      <Stack.Screen name="Splash" component={SplashScreen} />
      <Stack.Screen name="Onboarding" component={OnboardingScreen} />
      <Stack.Screen name="OnboardingChoiceScreen" component={OnboardingChoiceScreen} />
      <Stack.Screen name="InvitationVerificationScreen" component={InvitationVerificationScreen} />
      <Stack.Screen name="SignUp" component={SignUpScreen} />
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="PhoneVerificationScreen" component={PhoneVerificationScreen} />
      <Stack.Screen name="CodeVerification" component={CodeVerificationScreen} />
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} />
      <Stack.Screen name="PasswordVerificationCodeScreen" component={PasswordVerificationCodeScreen} />
      <Stack.Screen name="ResetPassword" component={ResetPasswordScreen} />
      <Stack.Screen name="EmailVerificationNotice" component={EmailVerificationNoticeScreen} />
      <Stack.Screen name="EmailVerificationResult" component={EmailVerificationResultScreen} />
      <Stack.Screen name="TwoFactorVerification" component={TwoFactorVerificationScreen} />
      <Stack.Screen name="SecurityChooser" component={SecurityChooserScreen} />
      <Stack.Screen name="TotpSetup" component={TotpSetupScreen} />
      <Stack.Screen name="TotpVerification" component={TotpVerificationScreen} />
      <Stack.Screen name="SmsVerification" component={SmsVerificationScreen} />
      <Stack.Screen name="BiometricSetupPrompt" component={BiometricSetupPromptScreen} />
      <Stack.Screen name="UnlockVault" component={UnlockVaultScreen} />

      {/* Onboarding Screens */}
      <Stack.Screen name="UserOnboarding" component={UserOnboardingScreen} />
      <Stack.Screen name="WhatIsNext" component={WhatIsNextScreen} />

      {/* AI Onboarding Screens */}
      <Stack.Screen name="AIOnboardingWelcome" component={AIOnboardingWelcomeScreen} />
      <Stack.Screen name="AIOnboardingTutorial" component={AIOnboardingTutorialScreen} />
      <Stack.Screen name="AIOnboardingChat" component={AIOnboardingChatScreen} />
      <Stack.Screen name="AIOnboardingPriorities" component={AIOnboardingPrioritiesScreen} />
      <Stack.Screen name="AIOnboardingPaused" component={AIOnboardingPausedScreen} />

      {/* Billing Screen */}

      {/* Legal Screens (accessible during signup) */}
      <Stack.Screen name="PrivacyPolicy" component={PrivacyPolicyScreen} />
      <Stack.Screen name="TermsOfService" component={TermsOfServiceScreen} />
    </Stack.Navigator>
  );
};

export default AuthNavigator;